export default [{
	id: 1,
	message: 'we are chatting it up'
},{
	id: 2,
	message: 'yes we are!'
}];
